import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Loader2, ExternalLink } from 'lucide-react';
import type { ARGenerationResponse } from '@/services/showroom';
import { ImageWithFallback } from '@/components/ImageWithFallback';
import { useNavigate } from 'react-router-dom';

interface ARPreviewModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  arData: ARGenerationResponse | null;
  isLoading: boolean;
}

export function ARPreviewModal({
  open,
  onOpenChange,
  arData,
  isLoading,
}: ARPreviewModalProps) {
  const navigate = useNavigate();

  const handleViewFullPage = () => {
    onOpenChange(false);
    navigate(`/showroom/analysis/${arData?.id}`);
  };
  console.log(arData);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[1000px] max-w-[1600px] h-[90vh] max-h-[90vh]  overflow-hidden">
        <DialogHeader>
          <DialogTitle>AR Preview</DialogTitle>
        </DialogHeader>

        <div className="flex-1 flex flex-col p-6 overflow-auto">
          {isLoading ? (
            <div className="flex flex-col items-center justify-center py-12 space-y-4">
              <Loader2 className="h-16 w-16 animate-spin text-primary" />
              <h3 className="text-xl font-semibold">Generating AR Preview</h3>
              {arData?.product?.name && (
                <p className="text-muted-foreground text-center">
                  Generating preview for{' '}
                  <span className="font-medium text-primary">
                    {arData.product.name}
                  </span>
                </p>
              )}
              <p className="text-sm text-muted-foreground mt-2">
                This may take a few moments...
              </p>
            </div>
          ) : arData ? (
            <>
              <div className="flex-1 min-h-[60vh] bg-muted/10 rounded-lg overflow-hidden flex items-center justify-center p-0">
                <div className="w-full h-full flex items-center justify-center">
                  <ImageWithFallback
                    src={arData.generatedImage}
                    alt={`${arData.product.name} in your room`}
                    width={1600}
                    height={900}
                    className="max-w-full max-h-full object-contain"
                    isStorageUrl={true}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                <div>
                  <h3 className="font-medium mb-2">Room Details</h3>
                  <div className="space-y-1 text-sm text-muted-foreground">
                    <p>Type: {arData.room.roomType}</p>
                    <p>Style: {arData.room.roomStyle}</p>
                    <p>
                      Size: {arData.room.roomArea.width_ft}ft ×{' '}
                      {arData.room.roomArea.height_ft}ft
                    </p>
                  </div>
                </div>

                <div>
                  <h3 className="font-medium mb-2">Product Details</h3>
                  <div className="space-y-1 text-sm text-muted-foreground">
                    <p className="font-medium text-foreground">
                      {arData.product.name}
                    </p>
                    <p>{arData.product.description}</p>
                    <p>Color: {arData.product.color}</p>
                  </div>
                </div>
              </div>

              <div className="flex justify-between pt-4">
                <Button
                  variant="outline"
                  onClick={handleViewFullPage}
                  className="flex items-center gap-2"
                >
                  <ExternalLink className="h-4 w-4" />
                  View Full Page
                </Button>
                <Button onClick={() => onOpenChange(false)}>Close</Button>
              </div>
            </>
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
}
